export default __webpack_public_path__ + "static/media/image-asset.5098b30a.png";